module.exports = __webpack_public_path__ + "img/image1.5ee3f0d6.jpg";